// ! Temporal rule. Remove when the module is ready.
// Disable eslint rule for no-unused-vars
/* eslint-disable no-unused-vars */

import React, { useEffect, useState, useMemo, useRef } from 'react';
import _ from 'lodash';
import { FilterQueryParams, downloadReport } from '../../../../helpers';
import { Card, CardBody, HeaderTitle, MenuSVG, Table } from '../../../../components';
import { useCollectionsUIContext } from '../context/CollectionsUIContext';
import { UIHelpers } from '../../../../constants/pages/UIHelpers';
import CollectionColumns from './CollectionColumns';
import RechargeModal from '../modal/RechargeModal';
import DownloadModal from '../modal/DownloadModal';
import MovementsDetail from '../modal/MovementDetail';
import { reportsService, usersService } from '../../../../services';
import page from '../../../../constants/pages/page';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CollectionCustomFilters from './filters/CollectionCustomFilters';
import moment from 'moment';
import { downloadCSV } from '../../../../helpers/download';
import axios from 'axios';
import { checkFileStatus } from '../../../../helpers/fibonacciHelper';

const replaceCommaPattern = /\[([^,]+),([^,\]]+)\]/;

export default function CollectionsTable () {
    // sortKeyMap
    const { t } = useTranslation();
    const { defaultSorted } = UIHelpers();

    const colectionFiltersRef = useRef();

    // Context state

    const collectionsUIContext = useCollectionsUIContext();
    const collectionsUIProps = useMemo(() => {
        return {
            isLoading: collectionsUIContext.isLoading,
            setIsLoading: collectionsUIContext.setIsLoading,
            queryParams: collectionsUIContext.queryParams,
            setQueryParams: collectionsUIContext.setQueryParams
        };
    }, [collectionsUIContext]);

    // List state
    const [collectionList, setCollectionList] = useState();
    const [totalCollections, setTotalCollections] = useState(0);
    const [percents, setPercents] = useState(1);

    // Modal state

    const [openRechargeModal, setOpenRechargeModal] = useState(false);
    const [openDownloadModal, setOpenDownloadModal] = useState(false);
    const [selectedTransaction, setSelectedTransaction] = useState({});
    const [rechargeShow, setRechargeShow] = useState({});

    // Transaction detail state

    const [openDetail, setOpenDetail] = useState(false);

    // Functions

    // console.log(colectionFiltersRef);

    async function fetchCollections (download, page) {
        // change state isLoading
        collectionsUIProps.setIsLoading(true);

        // Prepare options (order, pages and filters)
        const filters = collectionsUIProps.queryParams.filters || new FilterQueryParams();

        const options = {
            order: 'id_payment-DESC',
            pageSize: download || collectionsUIProps.queryParams.pageSize,
            page: page || collectionsUIProps.queryParams.pageNumber,
        };

        // Set filters on options.
        options.filters = filters.build();
        await usersService.getUserCollections(options)
            .then(collections => {
                setCollectionList(collections);
            })
            .catch(e => {
                console.error(e);
                return [];
            })
            .finally(() => {
                collectionsUIProps.setIsLoading(false);
            });
    };

    const getTotalCollections = async () => {
        collectionsUIProps.setIsLoading(true);
        const filters = collectionsUIProps.queryParams.filters || new FilterQueryParams();
        const options = {
            pageSize: 100000,
        };
        options.filters = filters.build();
        await usersService.getUserCollections(options)
            .then(collections => {
                setTotalCollections(collections.length);
            })
            .catch(e => {
                console.error(e);
            })
            .finally(() => {
                collectionsUIProps.setIsLoading(prevValue => !prevValue);
            });
    };

    const getData = async () => {
        await getTotalCollections();
        fetchCollections();
    };

    // Handle Modal
    const handleCloseModal = () => {
        setOpenRechargeModal(false);
        setOpenDetail(false);
    };

    const handleTransactionDetail = transfer => {
        setOpenDetail(true);
        setSelectedTransaction(transfer);
    };

    const replaceComma = (match, p1, p2) => {
        return `[${p1};${p2}]`;
    };

    const getDownloadFilters = () => {
        if (!JSON.stringify(collectionsUIProps?.queryParams?.filters?.filters)) return '';
        return JSON.stringify(collectionsUIProps?.queryParams?.filters?.filters)
            .replace(/[{}"]/g, '')
            .replace(/:/g, ' ')
            .replace(replaceCommaPattern, replaceComma);
    };

    const download = async () => {
        collectionsUIProps.setIsLoading(true);

        const fetchFile = (idFile) => {
            return checkFileStatus({ filters: `id eq ${idFile}` }, 60, 3);
        };
        const startDate = collectionsUIProps.queryParams?.filters?.filters?.payment_date?.be[0] || moment().subtract(730, 'days').format('YYYY-MM-DD HH:mm:ss');
        const endDate = collectionsUIProps.queryParams?.filters?.filters?.payment_date?.be[1] || moment().format('YYYY-MM-DD HH:mm:ss');
        const options = {
            idType: 28,
            startAt: startDate,
            endAt: endDate,
            metadata: {
                filters: getDownloadFilters(),
                order: 'id_payment-DESC',
            }
        };
        const nameTable = window.location.pathname.slice(1, window.location.pathname.length);
        const fileName = collectionsUIProps.queryParams?.filters?.filters?.payment_date?.be[0] ? `Reporte del ${options.startAt} al ${options.endAt} ${nameTable}.csv` : `Reporte ${nameTable}.csv`;
        await reportsService
            .createReport(options)
            .then(async (response) => {
                return await fetchFile(response.metadata.id_file);
            })
            .then(async (res) => {
                return await axios.get(res[0].description, { responseType: 'arraybuffer' });
            }
            )
            .then((response) => {
                collectionsUIProps.setIsLoading(false);
                downloadCSV(response.data, fileName);
            })
            .catch(() => {
                collectionsUIProps.setIsLoading(false);
            });
    };

    const resetFilters = () => {
        if (colectionFiltersRef.current) {
            colectionFiltersRef.current.reset();
        }
    };

    useEffect(() => {
        collectionsUIProps.setQueryParams(prev => ({ ...prev, pageSize: localStorage.getItem('sizePerPage') || page.pageSize }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (JSON.stringify(collectionsUIProps.queryParams.url) !== undefined) {
            getData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [collectionsUIProps.queryParams]);

    // Main Component

    return (
        <>
            <RechargeModal
                open={openRechargeModal}
                onClose={handleCloseModal}
                recharge={rechargeShow}
                transaction={selectedTransaction}
            />
            <DownloadModal
                open={openDownloadModal}
                percents={percents}
            />
            {openDetail && (
                <MovementsDetail
                    open={openDetail}
                    onClose={handleCloseModal}
                    transfer={selectedTransaction}
                />
            )}

            <Card>
                <Box >
                    <HeaderTitle
                        title={t('collections.table.title')}
                        total={totalCollections}
                        download={download}
                        reset={resetFilters}
                        icon={(<MenuSVG className='mr-1 mb-2' />)}
                        UIProps={collectionsUIProps}
                    />
                    <CollectionCustomFilters
                        ref={colectionFiltersRef}
                    />
                </Box>
                <CardBody>
                    <Table
                        data={collectionList}
                        columns={CollectionColumns({ handleTransactionDetail })}
                        sort={defaultSorted}
                        onChange={collectionsUIProps.setQueryParams}
                        isLoading={collectionsUIProps.isLoading}
                        total={totalCollections}
                        pagination={{
                            sizePerPage: collectionsUIProps.queryParams.pageSize,
                            page: collectionsUIProps.queryParams.pageNumber
                        }}
                    />
                </CardBody>
            </Card>
        </>
    );
};
